<template>
<div>
  <div class="container">
    <div class="title-box">
      <h1 class="title">{{results.title}}</h1>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <article class="content span12 product-page">
        <div class="row">    
          <div class="span5">
              <div v-on:click="showZoom(results.image_path_zoom);" style="cursor: zoom-in;">
              <img :src="results.image_path" width="500" height="500">
              
        </div>
    </div>

  <div class="span7">
    <div class="reviews-box hide">
      <div class="rating-box">
      <div style="width: 80%" class="rating">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="73px" height="12px"
        viewBox="0 0 73 12" enable-background="new 0 0 73 12" xml:space="preserve">
          <polygon fill-rule="evenodd" clip-rule="evenodd" fill="#1e1e1e" points="6.5,0 8,5 13,5 9,7.7 10,12 6.5,9.2 3,12 4,7.7 0,5 5,5"/>
          <polygon fill-rule="evenodd" clip-rule="evenodd" fill="#1e1e1e" points="66.5,0 68,5 73,5 69,7.7 70,12 66.5,9.2 63,12 64,7.7 60,5 65,5 "/>
          <polygon fill-rule="evenodd" clip-rule="evenodd" fill="#1e1e1e" points="21.5,0 23,5 28,5 24,7.7 25,12 21.5,9.2 18,12 19,7.7 15,5 20,5 "/>
          <polygon fill-rule="evenodd" clip-rule="evenodd" fill="#1e1e1e" points="51.5,0 53,5 58,5 54,7.7 55,12 51.5,9.2 48,12 49,7.7 45,5 50,5 "/>
          <polygon fill-rule="evenodd" clip-rule="evenodd" fill="#1e1e1e" points="36.5,0 38,5 43,5 39,7.7 40,12 36.5,9.2 33,12 34,7.7 30,5 35,5 "/>
        </svg>
      </div>
      </div>
      <span>5 review(s)</span>
      <span class="separator">|</span>
      <a href="#reviews" class="add-review">Add your review</a>
    </div>
    
    <div class="description">

      <table class="table table-bordered table-striped" style="font-size:16px">
        <tbody>
          <tr>
            <td style="text-align:left;color:#ee7f83bb;" colspan="2"><strong>{{results.category_name}}</strong></td>
          </tr>
          <tr>
            <td style="text-align:left;">Design No.:</td>
            <td style="text-align:right;width:120px;">{{results.design_no}}</td>
          </tr>
          <tr>
            <td style="text-align:left;">Weight:</td>
            <td style="text-align:right;">{{results.weight}}</td>
          </tr>
          <tr>
            <td style="text-align:left;">CT:</td>
            <td style="text-align:right;">{{results.cat}}</td>
          </tr>
          <tr>
            <td style="text-align:left;">Width:</td>
            <td style="text-align:right;">{{results.width}}</td>
          </tr>
          <tr  class="hide">
            <td style="text-align:left;">Enamel:</td>
            <td style="text-align:right;">{{results.enamel}}</td>
          </tr>                    
          <tr class="hide">
            <td style="text-align:left;"><strong>Rhodium:</strong></td>
            <td style="text-align:right;">{{results.rhodium}}</td>
          </tr>                    
          <tr class="hide">
            <td style="text-align:left;"><strong>Keywords:</strong></td>
            <td style="text-align:right;">{{results.keywords}}</td>
          </tr>                    
          <tr v-if="results.size_list != '' ">
            <td style="text-align:left;" >
              Size:
            </td>
            <td style="text-align:right;">
              <div  class="number">
                <select id="cboSize" style="width:110px;" v-on:change="size_change()" v-model="results.size">
                  <option v-if="results.size_list.split(',').length <= 0" value="" selected >none</option>
                  <option v-for="(sz,index) in results.size_list.split(',')" :key="index" :value="sz">{{sz}}</option>
                </select> 
              </div>
           </td>
          </tr>                    
        </tbody>
      </table>
      
    </div>
    <div class="clearfix"></div>
    <div class="price-box hide">
      <span class="price-old">$1500</span> 
      <span class="price"><i class="fa fa-inr"></i>{{results.price}}</span>
    </div>
    
    <div class="form-inline add-cart-form">
      <div class="number span2">
      <label>Pcs:</label>
      <input id="txtquantity" readonly type="number" step="1" min="1" v-model="results.qty">
      <div class="regulator">
        <a href="javascript:;" v-on:click="numUp()" class="number-up"></a>
        <a href="javascript:;" v-on:click="numDown()" class="number-down"></a>
      </div>
      </div>
      <button type="button" class="btn btn-large add-cart pull-right" v-if="results.mode == '0'" :id="'btnAddToCart' + results.id.toString()"  v-on:click="btnAddToCart_click">Add to Cart</button>
      <button type="button" class="btn btn-large add-cart pull-right" v-if="results.mode == '1'" :id="'btnUpdateCart' + results.id.toString() " v-on:click="btnUpdateCart_click">Update Cart</button>
      
    </div>
    
    <div class="actions hide">
      <a href="#" class="add-wishlist">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        width="16px" height="16px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve">
      <path fill="#1e1e1e" d="M11.335,0C10.026,0,8.848,0.541,8,1.407C7.153,0.541,5.975,0,4.667,0C2.088,0,0,2.09,0,4.667C0,12,8,16,8,16
        s8-4,8-11.333C16.001,2.09,13.913,0,11.335,0z M8,13.684C6.134,12.49,2,9.321,2,4.667C2,3.196,3.197,2,4.667,2C6,2,8,4,8,4
        s2-2,3.334-2c1.47,0,2.666,1.196,2.666,2.667C14.001,9.321,9.867,12.49,8,13.684z"/>
      </svg>
      </a>
      <a href="#" class="add-compare">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        width="16px" height="16px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve">
        <path fill="#1e1e1e" d="M16,3.063L13,0v2H1C0.447,2,0,2.447,0,3s0.447,1,1,1h12v2L16,3.063z"/>
        <path fill="#1e1e1e" d="M16,13.063L13,10v2H1c-0.553,0-1,0.447-1,1s0.447,1,1,1h12v2L16,13.063z"/>
        <path fill="#1e1e1e" d="M15,7H3V5L0,7.938L3,11V9h12c0.553,0,1-0.447,1-1S15.553,7,15,7z"/>
      </svg>
      </a>
    </div><!-- .actions -->
    </div>
      
        </div>
      </article>
    </div>
  
<div id="divZoom" class="fadeMe hide" style="padding-top: 50px;" >
    <span class="title" style="color: rgb(217, 145, 156); margin-left: 20px; margin-top: 10px; font-weight: normal; font-size: 22px; font-family: Arimo, sans-serif;"><strong>{{results.title}}</strong></span>
    <span class="pull-right">
    <button class="btn-small pull-right" style="margin-right:10px;opacity:0.4;background: #fff;color:#000" onclick="$('#divZoom').hide();"><i class="fa fa-times"></i></button>
    </span>
    <iframe id="ifr" src="'vendor/zoom.html?img=images/no-image.jpg'" style="width:100%;height:100%;overflow:visible;"></iframe>
  </div>
</div>
</div>

</template>
<script>
//import axios from 'axios'
import Vue from 'vue'
import {mapGetters, mapActions} from "vuex";
import $ from 'jquery'
import Common from '@/common.js'
import OnLoad from 'vue-onload'
import Vue2TouchEvents from 'vue2-touch-events'
import EventBus from '@/EventBus.js'

Vue.use(OnLoad);
Vue.use(Vue2TouchEvents)



export default {
	name:'ProductDescription',
   data: function(){
    return {
    results: [{cart:[],"size_list":"","pack":"1","qty":"1"}]
    }
  },  props: {
    msg: String
  },mounted: function() {

    //alert(this.$route.params.productId);
    this.getCart();
    Common.callServerFunction("Items/ItemController::Get",this.get_response,{'product':this.$route.params.productId},"Item");

    //axios.get("http://localhost/api/categories.php")
    //.then(response => {this.results = response.data})
    
  },
  computed:mapGetters(["Session","Cart","CartCount"]),
    watch:{
    //Session(newValue) { this.get_session_response(newValue)  },
    Cart(newValue) { this.response_cart_items(newValue)  },
    //CartCount(newValue) { this.results.cart_count = newValue  },
  },  
  methods:{
          ...mapActions(["addToCart","updateCartItem","getCart"]),
          touchHandler (event) {
            
            var purl =  $(event.target).attr('href');
            if(purl != undefined)
            {
              this.$router.push(purl);
            }else
            {
              purl = $(event.target).parent().attr('href');
              this.$router.push(purl);
            }

            //console.log($(event.target).parent())  // May be left / right / top / bottom
        },numUp()
          {
            var val = $("#txtquantity").val();
            if(val != "")
            {
              $("#txtquantity").val(parseInt(val)+1);
            }else
            {
              $("#txtquantity").val(1);
            }
          },
          numDown()
          {
            var val = $("#txtquantity").val();
            if(val != "")
            {
              if(parseInt(val) > 1)
              { 
                $("#txtquantity").val(parseInt(val) - 1);
              }else
              {
                $("#txtquantity").val(1);
              }
            }else
            {
              $("#txtquantity").val(1);
            }
          },showZoom: function(img)
          {
            
            // this.$refs.zoomer.reset();
            //$("#imgItemZoom").attr("src",img);
            
            $("#ifr").attr("src",encodeURI("vendor/zoom.html?img="+img.replace(Common.siteUrl + "resize/timthumb.php?src=","")));
            $("#divZoom").show();
          },btnUpdateCart_click()
          {

            var result = this.results;

            var size = "";
            var qty = result.pack;

            if(result.size_list != "")
              {
                size = $("#cboSize").val();
              }
              qty = $("#txtquantity").val();

              //alert(JSON.stringify({'id':result.id,'qty':qty,'sizes':size}));

              //this.updateCartItem({'id':result.id,'qty':qty,'sizes':size});
              
              Common.callServerFunction("Cart/CartController::UpdateCartItem",this.get_update_cart_response,{'id':result.id,'qty':qty,'sizes':size},"Cart");
          },
          size_change()
          {
            //alert(JSON.stringify(this.Cart));
            this.results.mode = 0;
            this.Cart.forEach((Citem) =>{
                if(Citem.id == this.results.id && Citem.size == this.results.size)
                {
                  this.results.qty = Citem.qty;
                  this.results.mode = 1;
                }
            });
              
          },response_cart_items:function(newValue)
        {
           if(newValue != ""){
              this.results.cart = newValue;
            } 
            Common.callServerFunction("Items/ItemController::Get",this.get_response,{'product':this.$route.params.productId},"Item");
            //this.loadOnMount();
        },
        get_update_cart_response:function(response)
        {
            this.results.cart = JSON.parse(response);
            this.getCart();
            //this.loadOnMount();
        },get_response:function(response)
          {	
            if(response == ""){
                //this.$router.push("/404");
                //return;
            }
            var rdata = JSON.parse(response);
            this.results = rdata;
            
            
                var jimage = [];

                this.Cart.forEach((Citem) =>{
                  if(rdata.id == Citem.id && rdata.size == Citem.size)
                  {
                      this.results.qty = Citem.qty;
                      this.results.size = Citem.size;
                      this.results.mode = 1;
                  }
                });

                jimage.push(rdata.image_path)
                jimage.push(rdata.image_path_zoom)
                this.preload = false
                Common.startAjaxLoader();
                this.$nextTick(function() {
                  this.$images.preload(jimage,
                    (completed, progress) => {
                      // progress indicator from 0 (no image loaded yet) to 1 (all images loaded)
                      console.log(Math.round(progress * 100))
                      // completed = true when all images are loaded
                      if (completed) {
                        this.preload = true
                        //console.log(completed);
                        $("#ifr").attr("src",encodeURI("vendor/zoom.html?img="+rdata.image_path_zoom.replace(Common.siteUrl + "resize/timthumb.php?src=","")));
                        eval('loadFunctions();');
                      }
                    }
                  )
                })

                //$(".item").eq(0).addClass('item active');


                          //$.get('./js/main.js', function(data) {
                        //eval(data);
                        //eval('setTimeout(loadFunctions(),1000);');

                //});
                Common.stopAjaxLoader();
         },
        response_btnAddToCart_click:function(response)
        {
          var rdata = JSON.parse(response);
          EventBus.$emit('cart_count', rdata.cart_count);
          Common.showSuccess("Item added to your cart");
          //$.grep(this.results.Rows,function(row){return (row.id === rdata.id)})[0].favourite = rdata.favourite;
        },
        btnAddToCart_click:function(event)
        { 
          if(event.target.tagName === "BUTTON")
          {
            var rid = this.results.id;
            var qty = $('#txtquantity').val();
            var cid = this.results.category_id;
            var price = this.results.price;
            var img = this.results.image_path;
            var pname = this.results.title;
            var weight = this.results.weight;
            
            
            var size = "";
            if(this.results.size_list != "")
            {
              size = $('#cboSize').val();
            }

            this.addToCart({'pid':rid,'price':price,'qty':qty,'img':img,'cid':cid,'pname':pname,'size':size,'weight':weight,'pack':this.results.pack});
            this.getCart();

            //Common.callServerFunction("Cart/CartController::AddToCart",this.response_btnAddToCart_click,{'pid':rid,'price':price,'qty':qty,'img':img,'cid':cid,'pname':pname},event);
          }

        },   
   }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
